import { TuitionModuleData, UseTuitionModule } from "./types";
import { useMonarchRule } from "../MonarchRulesProvider";

const CUSTOM_RULE_ID = "tuitionModule";

const useTuitionModule: UseTuitionModule = () => {
  const { isLoading, value } = useMonarchRule<{
    data: TuitionModuleData;
  }>(CUSTOM_RULE_ID, {});

  if (isLoading || !value) {
    return {
      isLoading,
      variant: "control",
    };
  }

  // Determine variant based on showModule data
  const { data } = value;
  const variant = data?.showModule ? "control" : "test";

  return {
    isLoading,
    variant,
    data,
  };
};

export default useTuitionModule;
